/**
 * Date and timestamp utility functions
 */

/**
 * Format UTC timestamp to local time string
 * @param {string|number} timestamp - UTC timestamp string (e.g., "2025-09-26T12:55:34.593048") or Unix timestamp (seconds since epoch)
 * @returns {string} - Formatted local time string
 */
export const formatTimestamp = (timestamp) => {
  try {
    if (!timestamp) return 'N/A';
    
    // Handle Unix timestamps (numbers)
    if (typeof timestamp === 'number') {
      const date = new Date(timestamp * 1000); // Convert seconds to milliseconds
      return date.toLocaleString();
    }
    
    // Handle UTC timestamps that don't have timezone indicators
    let dateString = timestamp;
    
    // If the timestamp doesn't end with 'Z' or have timezone info, assume it's UTC
    if (timestamp && !timestamp.includes('Z') && !timestamp.includes('+') && !timestamp.includes('-', 19)) {
      dateString = timestamp + 'Z';
    }
    
    const date = new Date(dateString);
    
    // Return formatted string in local timezone
    return date.toLocaleString();
  } catch (error) {
    console.warn('Error formatting timestamp:', timestamp, error);
    return String(timestamp);
  }
};

/**
 * Format date string to local time string (alias for formatTimestamp)
 * @param {string} dateString - Date string to format
 * @returns {string} - Formatted local time string
 */
export const formatDate = formatTimestamp;

/**
 * Format Unix timestamp to local time string (time only)
 * @param {number} unixTimestamp - Unix timestamp (seconds since epoch)
 * @returns {string} - Formatted local time string (time only)
 */
export const formatUnixTimestampTime = (unixTimestamp) => {
  try {
    if (!unixTimestamp) return '';
    
    const date = new Date(unixTimestamp * 1000);
    
    return date.toLocaleTimeString(undefined, {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    });
  } catch (error) {
    console.warn('Error formatting unix timestamp:', unixTimestamp, error);
    return '';
  }
};
/** "Oct 6, 2026, 2:14 PM" for an ISO time, in the viewer's time zone; '' when missing. */
export const formatWhen = (iso) => {
  if (!iso) return '';
  const date = new Date(iso);
  return Number.isNaN(date.getTime()) ? String(iso) : date.toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' });
};
